import { DetailedUser } from "@/user/user";

/**
 * Returns the initials of a user
 * @param userInfo - The user information
 * @returns The initials of the user
 */
export const getInitials = (userInfo: DetailedUser | undefined) => {
  if (!userInfo) return "?";

  const getFirstTwoLetters = (str?: string) =>
    str?.substring(0, 2).toUpperCase() || "";

  const initials =
    `${userInfo.first_name?.charAt(0) || ""}${userInfo.last_name?.charAt(0) || ""}`.toUpperCase();
  if (initials.trim()) return initials;

  return (
    getFirstTwoLetters(userInfo.first_name || "") ||
    getFirstTwoLetters(userInfo.last_name || "") ||
    getFirstTwoLetters(userInfo.email || "") ||
    "?"
  );
};

/**
 * Returns the full name of a user
 * @param user - The user information
 * @returns The full name of the user
 */
export const getUserFullName = (user: DetailedUser) => {
  const names = [user.first_name, user.last_name].filter(Boolean);
  return names.join(" ").trim() || "-";
};

/**
 * Returns the user's name or email if the name is not available
 * @param user - The user information
 * @returns The user's name or email
 */
export const getUserNameOrEmail = (user: DetailedUser | null | undefined) => {
  if (!user) return "";
  if (user.discarded_at) return "Deleted User";
  return getUserFullName(user) || user.email || "";
};

export const getAttributedUserName = (
  user: DetailedUser | null | undefined,
) => {
  if (!user) return null;
  if (user.discarded_at) return "Deleted User";
  return getUserFullName(user);
};
